<template>
  <div
    class="modal fade fixed-right modal-assessment"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div role="document" class="modal-dialog modal-dialog-vertical">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Overall Performance Assessment</h5>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="control-label">Open Date</label>

            <div class="input-group" :class="[validationClasses('open_date')]">
              <span class="input-group-prepend">
                <span class="input-group-text">
                  <font-awesome :icon="['far', 'calendar-alt']"/>
                </span>
              </span>

              <flatpickr
                class="form-control date-single"
                name="open_date"
                :config="dateConfig"
                v-validate=""
                data-vv-as="open date"
                v-model="assessmentOpenDate"
              />
            </div><!-- /.input-group -->

            <help-block field="open_date"/>
          </div>

          <div class="form-group">
            <label class="control-label">Due Date</label>

            <div class="input-group" :class="[validationClasses('due_date')]">
              <span class="input-group-prepend">
                <span class="input-group-text">
                  <font-awesome :icon="['far', 'calendar-alt']"/>
                </span>
              </span>

              <flatpickr
                class="form-control date-single"
                name="due_date"
                :config="dateConfig"
                v-validate=""
                data-vv-as="due date"
                v-model="assessmentDueDate"
              />
            </div><!-- /.input-group -->

            <help-block field="due_date"/>
          </div>

        </div>

        <div class="modal-footer">
          <button
            ref="closeButton"
            type="button"
            data-dismiss="modal"
            aria-label="Close"
          >
            Cancel
          </button>

          <ladda-button class="btn btn-sm btn-success" :click="saveAssessment" :validate="false">
            Save Assessment
          </ladda-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { helpers } from 'mixins/graduates'
import { handleServerErrors } from 'utils'
import Flatpickr from 'vue-flatpickr-component'
import { graduateMethods, graduateAssessmentsMethods } from 'vx/helpers'

export default {
  mixins: [helpers],

  props: {
    graduate: {
      required: false,
      type: Object
    }
  },

  components: {
    Flatpickr
  },

  data () {
    return {
      dateConfig: {
        altInput: true,
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d'
      }
    }
  },
  methods: {
    ...graduateMethods,
    ...graduateAssessmentsMethods,

    resetComponent () {
      this.resetGraduateAssessment()

      this.$validator.reset()
    },

    async storeAssessment () {
      await this.storePerformanceAssessment({
        graduate: this.graduate,
        payload: {
          open_date: this.graduate.assessment.open_date,
          due_date: this.graduate.assessment.due_date
        }
      })
    },

    async saveAssessment () {
      try {
        if (this.isEditing) {
        } else {
          await this.storeAssessment()
        }

        this.$validator.reset()
        this.$noty.success('Assessment saved successfully.')
        this.$refs.closeButton.click()
      } catch (e) {
        handleServerErrors(e, this.$validator)
      }
    }
  },
  beforeDestroy () {
    window.$(this.$el).off('show.bs.modal', this.resetGraduateAssessment)
    this.resetGraduateAssessment()
  },

  computed: {
    isEditing () {
      return this.graduate.assessment && this.graduate.assessment.id
    },
    assessmentOpenDate: {
      get () {
        const defaultDate = this.graduate.program ? this.graduate.program.open_date : ''

        if (this.graduate.assessment) {
          return this.graduate.assessment.open_date || defaultDate
        }

        return defaultDate
      },
      set (value) {
        if (this.graduate.assessment) {
          this.graduate.assessment.open_date = value
        }
      }
    },
    assessmentDueDate: {
      get () {
        const defaultDate = this.graduate.program ? this.graduate.program.due_date : ''

        if (this.graduate.assessment) {
          return this.graduate.assessment.due_date || defaultDate
        }

        return defaultDate
      },
      set (value) {
        if (this.graduate.assessment) {
          this.graduate.assessment.due_date = value
        }
      }
    }
  }
}
</script>
